module.exports = __webpack_public_path__ + "static/img/animation4.62a6b2c.png";